import { clsx } from "clsx";
import type { IconProps } from "./types";

export const ErrorIcon = ({ className }: IconProps) => (
  <span
    className={clsx(
      "flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-error text-sm text-white",
      className,
    )}
  >
    !
  </span>
);
